import { MessageDescriptor } from 'react-intl'
import { ConsumerRoute } from '../../../domain/consumer/consumer-routes/consumer-route.enum'
import { ConsumerWorkflowStepType } from '../../../domain/consumer/consumer-workflow/consumer-workflow-step-type.enum'
import { PageTitleMessages } from './page-title.messages'

const VENDOR_SLUG = '/vendor/:vendorId'

type VendorWorkflowKey =
  `${typeof VENDOR_SLUG}/${Exclude<ConsumerWorkflowStepType, ConsumerWorkflowStepType.ConsumerAutoSubmit>}`
type AutoSubmitKey = `/${ConsumerWorkflowStepType.ConsumerAutoSubmit}`

type PageTitleKey = ConsumerRoute | VendorWorkflowKey | AutoSubmitKey

export const PAGE_TITLE_MAP: Record<PageTitleKey, MessageDescriptor> = {
  // ── Post-submission ──
  [ConsumerRoute.SubmitApproved]: PageTitleMessages.approved,
  [ConsumerRoute.SubmitOffer]: PageTitleMessages.yourOffers,
  [ConsumerRoute.SubmitNoOfferAvailable]: PageTitleMessages.noOfferAvailable,
  [ConsumerRoute.SubmitError]: PageTitleMessages.somethingWentWrong,
  [ConsumerRoute.SubmitLoading]: PageTitleMessages.processing,

  // ── Merchant selection ──
  [ConsumerRoute.SelectMerchantSuccess]: PageTitleMessages.merchantSelected,
  [ConsumerRoute.SelectMerchant]: PageTitleMessages.selectMerchant,

  // ── Offer unsubscribe ──
  [ConsumerRoute.OfferUnsubscribeLoading]: PageTitleMessages.processing,
  [ConsumerRoute.OfferUnsubscribeSuccess]: PageTitleMessages.unsubscribed,
  [ConsumerRoute.OfferUnsubscribeError]: PageTitleMessages.unsubscribeError,
  [ConsumerRoute.OfferUnsubscribe]: PageTitleMessages.unsubscribe,

  // ── Authentication ──
  [ConsumerRoute.Authenticate]: PageTitleMessages.verifyIdentity,

  // ── Workflow steps ──
  [`${VENDOR_SLUG}/${ConsumerWorkflowStepType.ConsumerReviewAsset}`]:
    PageTitleMessages.reviewAsset,
  [`${VENDOR_SLUG}/${ConsumerWorkflowStepType.ConsumerNameForm}`]:
    PageTitleMessages.yourName,
  [`${VENDOR_SLUG}/${ConsumerWorkflowStepType.ConsumerPhoneForm}`]:
    PageTitleMessages.phoneNumber,
  [`${VENDOR_SLUG}/${ConsumerWorkflowStepType.ConsumerPhoneValidation}`]:
    PageTitleMessages.verifyPhone,
  [`${VENDOR_SLUG}/${ConsumerWorkflowStepType.ConsumerAssetSubtypeForm}`]:
    PageTitleMessages.assetDetails,
  [`${VENDOR_SLUG}/${ConsumerWorkflowStepType.ConsumerDobForm}`]:
    PageTitleMessages.dateOfBirth,
  [`${VENDOR_SLUG}/${ConsumerWorkflowStepType.ConsumerAddressForm}`]:
    PageTitleMessages.yourAddress,
  [`${VENDOR_SLUG}/${ConsumerWorkflowStepType.ConsumerEmailForm}`]:
    PageTitleMessages.emailAddress,
  [`${VENDOR_SLUG}/${ConsumerWorkflowStepType.ConsumerNetIncome}`]:
    PageTitleMessages.netIncome,
  [`${VENDOR_SLUG}/${ConsumerWorkflowStepType.ConsumerSubmit}`]:
    PageTitleMessages.reviewAndSubmit,
  [`/${ConsumerWorkflowStepType.ConsumerAutoSubmit}`]:
    PageTitleMessages.submitting,

  // ── Asset type selection & product loading ──
  [ConsumerRoute.SelectAssetType]: PageTitleMessages.selectAssetType,
  [ConsumerRoute.LoadingProduct]: PageTitleMessages.loading,

  // ── Generic vendor page & root ──
  [ConsumerRoute.GenericVendorPage]: PageTitleMessages.loading,
  [ConsumerRoute.RouteResolver]: PageTitleMessages.loading,
}
